(function () {
  const startTicker = (el) => {
    if (el.classList.contains("slider_started")) return;
    el.classList.add("slider_started");

    const tickerId = el.getAttribute("data-ticker-id");
    const tickerSpeed = parseFloat(el.getAttribute("data-ticker-speed")) * 1000;

    const swiperEl = el.querySelector(".swiper");
    if (!swiperEl) return;

    const tickerSwiper = new Swiper(`.ticker-js-${tickerId}`, {
      slidesPerView: "auto",
      speed: tickerSpeed,
      initialSlide: 0,
      loop: true,
      loopedSlides: 50,
      allowTouchMove: false,
      waitForTransition: false,
      watchSlidesProgress: false,
      observer: true,
      observeParents: true,
      observeSlideChildren: true,
      autoplay: {
        delay: 0,
        disableOnInteraction: false,
      },
    });

    const recalc = () => {
      tickerSwiper.update();
      if (tickerSwiper.autoplay) tickerSwiper.autoplay.start();
    };

    // Images can measure as 0-width if Swiper inits before they load.
    const imgs = el.querySelectorAll("img");
    imgs.forEach((img) => {
      if (img.complete && img.naturalWidth > 0) return;
      img.addEventListener("load", recalc, { once: true });
      img.addEventListener("error", recalc, { once: true });
    });

    // Kick autoplay right after init instead of waiting for window.load.
    // (Text tickers have no images, so the img path above never fires.)
    requestAnimationFrame(recalc);
    // Web fonts change the measured text width after Swiper's first pass —
    // re-measure once they're ready so the marquee isn't stuck.
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(recalc);
    }
  };

  const tickSlider = () => {
    document.querySelectorAll(".ticker").forEach(startTicker);
  };

  const refreshAll = () => {
    document.querySelectorAll(".ticker .swiper").forEach((sw) => {
      if (sw.swiper) {
        sw.swiper.update();
        if (sw.swiper.autoplay) sw.swiper.autoplay.start();
      }
    });
  };

  tickSlider();

  document.addEventListener("shopify:section:load", function () {
    setTimeout(tickSlider, 100);
  });

  window.addEventListener("load", refreshAll);

  document.addEventListener("visibilitychange", function () {
    if (!document.hidden) refreshAll();
  });
})();